// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2-8iO","header":"Messages_header__1ekwe"};